import { gql } from 'graphql-request'

const GET_ALL_PUBLISHER_APPS = gql`
  query listApplications($publisherId: ID) {
    applications(publisherId: $publisherId) {
      clientSecurityToken
      id
      name
      placements {
        id
        name
      }
      platform
      publisher {
        id
        name
      }
      rankingSourceAppId
      rewardCallbackToken
      rewardCallbackUrl
      sdkSecurityToken
      status
      storeInfo
      storeUrl
      notInStore
      apiFeedEnabled
      apiFeedKey
      virtualCurrencies {
        id
        name
      }
    }
  }
`

export default GET_ALL_PUBLISHER_APPS
